<script setup>
import { truncateString } from "@/utils/utils";

const props = defineProps({
  imageObj: { type: Object, required: true },
  width: { type: String, default: "200px" }
});

const handleClick = () => {
  window.open(props.imageObj.url, "_blank");
};
</script>

<template>
  <div
    class="generic-thumbnail"
    :style="{ width: props.width, height: props.width }"
    @click="handleClick"
  >
    <Icon icon="paperclip" class="file-icon" />
    <div class="file-name">
      {{
        truncateString(
          imageObj.media_name ? imageObj.media_name : imageObj.url,
          12
        )
      }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
.generic-thumbnail {
  position: relative;
  aspect-ratio: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5em;
  border-radius: 8px;
  background: $neutral-150;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition:
    transform 0.2s,
    box-shadow 0.2s;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  }

  .file-icon {
    width: 2em;
    height: 2em;
    color: $neutral-400;
  }

  .file-name {
    padding: 2px 10px;
    font-size: $font-size-xs;
    color: $neutral-400;
    text-align: center;
    word-break: break-word;
  }
}
</style>
